(function () {
  function init() {
    var tracker = document.getElementById('header-scroll-tracker');
    if (!tracker) return;

    var observer = new IntersectionObserver(
      function (entries) {
        entries.forEach(function (entry) {
          document.body.classList.toggle('floating-nav--scrolled', !entry.isIntersecting);
        });
      },
      { threshold: 0 }
    );

    observer.observe(tracker);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init);
  } else {
    init();
  }
})();
